module.exports = __webpack_public_path__ + "static/media/boss-hidden-power-block.4511e386.png";